<template>
    <div class="logtable">
        <div class="table_wrapper">
            <table>
                <thead>
                <tr>
                    <th>Tidspunkt</th>
                    <th>Staff</th>
                    <th>Handling</th>
                    <th>Før</th>
                </tr>
                <tr class="mobile">
                    <th colspan="4">Log</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="logs.length === 0">
                    <td colspan="4">
                        Ingen log eksisterer
                    </td>
                </tr>
                <tr v-for="l in logs">
                    <td class="col-time"><span>{{$utils.parseDate(l.created)}}</span></td>
                    <td class="col-staff">
                        <div class="user-float">
                            <router-link :to="getGoToUser(l.actor_name, 'staff')">
                                <img v-if="l.actor_uuid !== null && l.actor_uuid !== 'CONSOLE'"
                                     :src="'https://visage.surgeplay.com/face/25/'+l.actor_uuid"/>
                                <img v-else src="../../assets/console.png"/>
                                <span v-if="l.actor_uuid !== null && l.actor_uuid === '49979a7a-01f5-4615-9cd1-358875a629a3'">FreakyVille</span>
                                <span v-else>{{l.actor_name}}</span>
                            </router-link>
                        </div>
                    </td>
                    <td class="col-action" v-if="l.valueBefore === null" colspan="2"><span>{{l.action_message}}</span></td>
                    <td class="col-action" v-else><span>{{l.action_message}}</span></td>
                    <td class="col-before" v-if="l.valueBefore !== null" ><span>{{l.valueBefore}}</span></td>
                </tr>
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td>Permanent = true</td>-->
                <!--                    <td>25-05-2020, 14:39</td>-->
                <!--                </tr>-->
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td>Begrundelse = VPN</td>-->
                <!--                    <td>VPN + Smurf til DasMeAyy mfl.</td>-->
                <!--                </tr>-->
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td>Udløber = 29-05-2020, 19:20</td>-->
                <!--                    <td>Permanent</td>-->
                <!--                </tr>-->
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td colspan="2">Unban = For det er synd for den</td>-->
                <!--                </tr>-->
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td colspan="2">Unban</td>-->
                <!--                </tr>-->
                <!--                <tr>-->
                <!--                    <td>23-05-2020, 14:33</td>-->
                <!--                    <td>-->
                <!--                        <div class="user-float">-->
                <!--                            <a href="#">-->
                <!--                                <img src="https://placehold.it/25x25"/>-->
                <!--                                <span>aNdIrEas</span>-->
                <!--                            </a>-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                    <td>Server = NPrison</td>-->
                <!--                    <td>Alle</td>-->
                <!--                </tr>-->
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['logs'],
        computed: {},
        methods: {
            getGoToUser(username, type) {
                return {name: 'mc_' + type, params: {username, page: 1}};
            }
        },
    }
</script>

<style lang="scss" scoped>
    .logtable {
        margin-top: 25px;
    }

    table {
        width: 100%;
        font-size: 16.5px;
        margin-bottom: 0;
        text-align: center;
        border-collapse: collapse;
        background-color: #343a40;

        thead {
            background: #262a2d;

            tr.mobile {
                display: none;
            }

            th {
                vertical-align: middle;
                overflow-wrap: break-word;
                padding: .75rem;
                font-weight: bold;

                &.small {
                    width: 15%;
                }

                &.type {
                    width: 10%;
                }
            }
        }

        tbody {
            tr {
                background-color: rgba(0, 0, 0, .05);

                &:nth-of-type(odd) {
                    background-color: hsla(0, 0%, 100%, .05);
                }

                td {
                    vertical-align: middle;
                    overflow-wrap: break-word;
                    padding: .75rem;

                    a {
                        color: #fff;
                        text-decoration: none;
                    }
                }


                .user-float a {
                    color: #fff;
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                    justify-content: center;

                    img {
                        border-radius: 2px;
                        margin-right: 8px;
                    }
                }

                .expired {
                    padding-top: 5px;
                    font-style: italic;
                    font-size: 15px;
                    color: #878e94;
                    max-width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .badge {
                    padding: 10px 5px;
                    border-radius: 2px;
                    width: 65px;
                    text-transform: uppercase;
                    font-weight: bold;
                    letter-spacing: 1px;
                    display: inline-block;
                    text-align: center;

                    &.badge-nameban {
                        background-color: #1462a2;
                    }

                    &.badge-ban {
                        background-color: #a21414;
                    }

                    &.badge-kick {
                        background-color: #ce8720;
                    }

                    &.badge-mute {
                        background-color: #607d8b;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1400px) {
    }

    @media screen and (max-width: 990px) {
        table {
            thead {

                tr {
                    display: none;
                }

                tr.mobile {
                    display: unset;
                }
            }

            tbody {
                tr {
                    padding: 10px 0;
                    display: block;
                }

                td {
                    position: relative;
                    width: 100%;
                    display: block;
                    text-align: left;

                    > span {
                        display: block;
                        padding-left: 35%;
                    }

                    a {
                        padding-left: 35%;
                        justify-content: flex-start !important;
                    }

                    .user {

                        img {
                            padding-bottom: 0px;
                            padding-right: 5px;
                            display: inline !important;
                        }
                    }

                    &:before {
                        position: absolute;
                        width: 40%;
                        left: 10px;
                        top: 0;
                        padding: .75rem;
                    }

                    &.col-time:before {
                        content: "Tidspunkt";
                    }

                    &.col-action:before {
                        content: "Handling";
                    }

                    &.col-staff:before {
                        content: "Straffet af";
                    }

                    &.col-before:before {
                        content: "Før";
                    }
                }
            }
        }
    }

    @media screen and (max-width: 760px) {
    }

    @media screen and (max-width: 585px) {
    }
</style>
